export default __webpack_public_path__ + "static/media/Dorothy_Kolb_AHV_In_Moms_We_Trust.8fca0d43.jpg";